<template>
  <el-dialog
    :title="$t('deleteGold.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div class="modal-body">
      <p align="center">{{ $t('deleteGold.confirmDeleteGold') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('deleteGold.cancel') }}</el-button>
      <el-button type="primary" @click="deleteGold">{{ $t('deleteGold.confirmDelete') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteGold } from '@/api/admin/gold/goldApi'

export default {
  name: 'DeleteGold',
  data() {
    return {
      dialogVisible: false,
      deleteGoldInfo: {}
    }
  },
  methods: {
    open(gold) {
      this.deleteGoldInfo = { ...gold }
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    deleteGold() {
      deleteGold(this.deleteGoldInfo)
        .then(response => {
          console.log(response)
          this.$message.success(this.$t('deleteGold.deleteSuccess'))
          this.$emit('refresh')
          this.handleClose()
        })
        .catch(error => {
          this.$message.error(error.message || this.$t('deleteGold.deleteFailed'))
        })
    }
  }
}
</script>

<style scoped>
.modal-body {
  padding: 20px;
  text-align: center;
}
</style>